
    import { v4 as uuidv4 } from 'uuid';
    export function statisticsToBarChartDataBuilder(label, statisticsObject) 
    {
        statisticsObject.sort((a, b) => a.value - b.value);
        var barData = {};
        Object.keys(statisticsObject[0]).forEach(function(key) {
            barData[key] = [];
        });
        for (const [key, value] of Object.entries(statisticsObject)) {
            for (const [objectKey, objectValue] of Object.entries(value)) {
                barData[objectKey].push(objectValue);
            }
        }

        var chartData = {
            labels: barData['value'],
            datasets:  [
                {
                    id: uuidv4(),
                    label: label,
                    data: barData['relative']
                }
            ]
        }
        return chartData;
    }